import { Transition } from '@headlessui/react';

export default Transition;
